import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
import { api } from 'common';
/**
 * ComponentName: 头像显示
 * 组件说明：
 * round: 是否是圆形，默认是正方形
 * eg:
 * <cl-avatar :src="avatar" :round="true" width="32" height="32"></cl-avatar>
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'cl-avatar',
    props: {
        src: {
            type: String,
            default: "",
        },
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        round: {
            // true是圆形头像 默认是false（方形头像
            type: Boolean,
            default: false,
        },
        bgc: {
            type: String,
            default: "#f0f0f0",
        },
        radius: {
            type: String,
            default: "",
        },
        enlarge: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["cl_avatar", { round: __props.round }]),
                style: _normalizeStyle({
                    width: __props.width + 'px',
                    height: __props.height + 'px',
                    borderRadius: __props.radius,
                    backgroundColor: __props.bgc,
                })
            }, [
                _createElementVNode("img", {
                    src: __props.src || _unref(api).defaultAvatarUrl,
                    alt: ""
                }, null, 8, _hoisted_1)
            ], 6));
        };
    }
});
